<template>
  <PageShell active="inquiry">
    <section class="inquiry-page">
      <h1>New Inquiry</h1>
      <p class="intro">If you know the exact part numbers required, please use the search form, add the parts to the
        shopping cart and submit your order. Alternatively, if you do not know the part numbers, please fill out the
        following form.</p>
      <p class="intro2">Please note, buybuyGENUINE cannot supply windshields, side windows, or rear windows internationally.</p>
      <form class="inquiry-form" @submit.prevent="submitInquiry">
        <label>
          <span><b>*</b>VIN or Frame No</span>
          <el-input v-model="form.vin" placeholder="5 to 24 characters" class="form-input" />
        </label>
        <label>
          <span><b>*</b>Required parts</span>
          <el-input v-model="form.parts" type="textarea"
            placeholder="Please describe either parts you need or the problem your car has" class="form-textarea"
            :rows="4" />
        </label>
        <label>
          <span>Car details</span>
          <el-input v-model="form.carDetails" placeholder="Your car details(optional)" class="form-input" />
        </label>
        <p>Your inquiry will be processed within 1-2 business days.</p>
        <button type="submit" :disabled="loading">Send Inquiry</button>
      </form>
    </section>
  </PageShell>
</template>

<script>
import PageShell from '@/components/common/PageShell.vue'
import { getToken } from '@/util/token-util.js'

export default {
  name: 'InquiryPage',
  components: {
    PageShell
  },
  data() {
    return {
      form: { vin: '', parts: '', carDetails: '' },
      loading: false
    }
  },
  methods: {
    async submitInquiry() {
      if (!this.form.vin.trim()) {
        this.$message.error('VIN or Frame No is required')
        return
      }
      if (!this.form.parts.trim()) {
        this.$message.error('Required parts is required')
        return
      }
      if (!getToken()) {
        this.$message.warning('Please log in first')
        this.$router.push({ name: 'home' })
        return
      }
      this.loading = true
      try {
        await this.$api({
          url: 'Inquiry/submit',
          method: 'post',
          data: {
            vin_or_frame: this.form.vin,
            required_parts: this.form.parts,
            car_details: this.form.carDetails
          }
        })
        this.$message.success('Inquiry submitted')
        this.form = { vin: '', parts: '', carDetails: '' }
      } catch (e) {
        this.$message.error('Failed to submit inquiry')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.inquiry-page {
  max-width: 1100px;
  min-height: 690px;
  margin: 0 auto;
  padding: 34px 20px 70px;
}

h1 {
  margin: 0 0 22px;
  color: #333;
  font-size: 26px;
}

.intro {
  max-width: 1280px;
  margin-bottom: 16px;
  color: #333;
  font-size: 16px;
  line-height: 1.5;
}
.intro2 {
  max-width: 1280px;
  margin-bottom: 26px;
  color: #333;
  font-size: 16px;
  line-height: 1.5;
}

.inquiry-form {
  width: 860px;
}

.inquiry-form label {
  display: block;
  margin-bottom: 36px;
}

.inquiry-form span {
  display: block;
  margin-bottom: 12px;
  color: #333;
  font-size: 14px;
  font-weight: 700;
}

.inquiry-form b {
  color: #F34B01;
}

.inquiry-form .form-input ::v-deep .el-input__inner,
.inquiry-form .form-textarea ::v-deep .el-textarea__inner {
  width: 100%;
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  color: #333;
  font-size: 14px;
  outline: none;
}

.inquiry-form .form-input ::v-deep .el-input__inner {
  height: 40px;
  padding: 0 14px;
}

.inquiry-form .form-textarea ::v-deep .el-textarea__inner {
  height: 108px;
  padding: 14px;
  resize: none;
}

.inquiry-form p {
  margin: 0 0 36px;
  color: #333;
  font-size: 14px;
}

.inquiry-form button {
  width: 146px;
  height: 44px;
  border: 0;
  border-radius: 4px;
  background: #F34B01;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
}
</style>
